import { CollectError } from './config';
import { filesToBase64 } from './vg-react-input-field/utilities/file-upload';

function deepMerge(result, k, value) {
  if (k.length === 1) {
    result[k[0]] = value;
  } else {
    result[k[0]] = result[k[0]] || {};
    deepMerge(result[k[0]], k.slice(1), value);
  }
  return result;
}

export const SERIALIZATION_STRATEGIES = {
  flat(value) {
    return value;
  },

  deep(value) {
    return Object.keys(value).reduce((result, key) => {
      deepMerge(result, key.split('.'), value[key]);
      return result;
    }, {});
  },

  replace: function (value, options) {
    // replace old with new, n times
    if (!options.old) {
      throw new CollectError(
        'library: vg-secure-form, feature: serializers,  replace_error: options.old is not defined'
      );
    }

    if (!options.old) {
      throw new CollectError(
        'library: vg-secure-form, feature: serializers,  replace_error: options.new is not defined'
      );
    }

    let new_substr = options.new;

    if (!options.count) {
      let old_substr = new RegExp(options.old, 'g');
      value = value.replace(old_substr, new_substr);
      return value;
    }

    let N = options.count;
    let old_substr = new RegExp(options.old);
    while (--N + 1) {
      value = value.replace(old_substr, new_substr);
    }
    return value;
  },

  separate: function (value, options) {
    let arr = value.replace(/ /g, '').split('/');
    let result = {};

    result[options.monthName] = arr[0];
    result[options.yearName] = arr[1];
    return result;
  },

  toBase64: (value) => {
    /**
     * Convert files into an array of base64 strings
     */
    if (value instanceof FileList) {
      return filesToBase64(value);
    }
    /**
     * Convert object into a base64 string
     */
    if (typeof value === 'object' && value !== null) {
      try {
        value = JSON.stringify(value);
      } catch (e) {
        throw new Error("toBase64: Can't stringify value.");
      }
    }
    /**
     * Convert string into a base64 string
     */
    try {
      return window.btoa(value);
    } catch (e) {
      throw new Error("toBase64: Can't convert value to base64.");
    }
  },
};

export default async function serialize(value, serializers) {
  for (let s = 0; s < serializers.length; s++) {
    const serializer = serializers[s];
    if (SERIALIZATION_STRATEGIES[serializer.name]) {
      value = await SERIALIZATION_STRATEGIES[serializer.name](value, serializer.options || {});
    }
  }
  return value;
}
